// extracted by mini-css-extract-plugin
export default {"loader-wrap":"BarLoader_loader-wrap__TGJbB","loader":"BarLoader_loader__Irmgt","loader2":"BarLoader_loader2__ckbsq"};